<template>
  <v-container fluid fill-height>
    <v-toolbar color="green darken-1" dark app fixed flat>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3 hidden-sm-and-down">
        <a :href="`${webUrl}`" target="_blank">
          <img src="@/assets/logo.png" style="width: 100px; height: 70px;" alt>
        </a>
      </v-toolbar-title>
      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <div class="text-xs-center hidden-sm-and-down">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn flat @click="showMessage">My Profile</v-btn>
            <v-btn icon large v-on="on">
              <v-icon>person_outline</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="(item, index) in items"
              :key="index"
              @click="menuAction(item.actionType)"
            >
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <v-navigation-drawer
          v-model="drawer"
          width = "200"
          id = "drawer"
          clipped
          temporary
          app
          hide-overlay
          disable-resize-watcher
          class="hidden-md-and-up"
        >
        <v-btn class="pl-2" flat @click="showMessage">My Profile</v-btn>
        <!-- <v-btn icon large v-on="on">
          <v-icon>person_outline</v-icon>
        </v-btn> -->
        <v-btn icon large>
          <v-icon>person_outline</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, index) in items"
            :key="index"
            @click="menuAction(item.actionType)"
          >
            <v-list-tile-title>{{ item.text }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
    </v-navigation-drawer>
    <v-layout wrap style="margin-top: 150px">
        <v-flex xs12>
            <center><span style="color: red; font-size: 16px">Your account has expired. Please renew subscription.</span></center>
        </v-flex>
      <v-flex xs12 sm3 v-for="packageItem in packages" v-bind:key="packageItem._id" class="px-2">
        <v-card>
          <v-layout wrap class="pa-3 mb-2">
            <v-flex xs12 class="title text-xs-center">{{packageItem.name}}</v-flex>

            <v-flex xs12 class="pt-3">
              <p>{{packageItem.description}}</p>
            </v-flex>

            <v-flex xs12 class="pa-1 title text-xs-center">Features</v-flex>

            <v-flex xs12>
              <ul>
                <li v-for="(feature, index) in packageItem.features" v-bind:key="index">
                  <v-icon>arrow_right</v-icon>
                  {{feature}}
                </li>
              </ul>
            </v-flex>

            <v-flex xs12 class="pa-1 title text-xs-center mt-2">Choose Option</v-flex>

            <v-flex xs12 class="mt-3">
              <v-layout wrap class="flex-column mb-2">
                <div v-for="(option, index) in packageItem.options" class="d-flex">
                    <span class="mr-2">{{option.time}}</span>
                    <v-radio-group v-model="radioGroup" class="pt-0 mt-0 package-currency">
                      <v-radio
                        class="mb-0"
                        :key="`ksh${index}`"
                        :label="`Kshs. ${option.cost}`"
                        :value="{'cost': option.cost, '_id': option._id,'time': option.time, 'duration': option.duration, 'currency': 'kes'}"
                      ></v-radio>
                      <v-radio
                        v-if="packageItem.enable_usd == true"
                        class="mb-0"
                        :key="`usd${index}`"
                        :label="`USD ${option.cost_usd}`"
                        :value="{'cost': option.cost_usd, '_id': option._id,'time': option.time, 'duration': option.duration, 'currency': 'usd'}"
                      ></v-radio>
                    </v-radio-group>
                  </div>
              </v-layout>
            </v-flex>

            <v-flex xs12 class="text-xs-center">
              <v-btn
                v-if="radioGroup!=null"
                class="green darken-1"
                dark
                :to="`/vip_sonko/packages/subscribe/${packageItem._id}/${radioGroup._id}?time=${radioGroup.time}&&cost=${radioGroup.cost}&&duration=${radioGroup.duration}&&currency=${radioGroup.currency}`"
              >
                <v-icon left>check</v-icon>Select Plan
              </v-btn>
              <v-btn v-else class="green darken-1" dark>
                <v-icon left>check</v-icon>Select Plan
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- app snackbar -->
    <app-snackbar ref="snackbar"></app-snackbar>
    <!-- end -->

  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "packagesList",
  computed: {
    ...mapGetters(["user"]),
     ...mapGetters(["webUrl"])
  },
  data() {
    return {
      radios: null,
      radioGroup: null,
      packages: [],
      items: [
        { text: "Log Out", actionType: "logout" }
      ],
      drawer: false
    };
  },
  methods: {
    menuAction(data) {
      console.log(this.user);
      if (data == "logout") {
        const accountType = this.user.accountType;
        this.$store.commit("removeUser");
        localStorage.removeItem("token");
        this.$router.push(`/login/${accountType}/normal`);
      } else if (data == "account") {
        this.$router.push("/vip_sonko/profile");
      }
    },
    showMessage() {
      this.$refs.snackbar.show("Please select a plan and pay to complete your profile , if you have paid contact our customer service for help.", "red");
    }
  },
  created() {
    this.$store.dispatch("get", "/packages/vip").then(res => {
      this.packages = res.packages;
    });
  }
};
</script>

<style scoped>
.options {
  border-bottom: 1px solid #eeeeee;
}

ul li {
  list-style: none;
}

.v-input--radio-group .v-input__slot {
  margin-bottom: 4px;
}
</style>



